/**
 * ==========================================
 * CleverTap Custom Events
 * ==========================================
 */

const CleverTapEvents = {

    pageViewed() {

        if (typeof clevertap === "undefined") return;
        if (!window.shopifyPageData) return;

        const pageData = window.shopifyPageData;

        clevertap.event.push("Page Browsed", {
            "Page URL": pageData.pageUrl,
            "Page Title": pageData.pageTitle,
            "Page Type": pageData.pageType,
            "Language": pageData.language,
            "Currency": pageData.currency
        });

        console.log("🔵 CleverTap :: Page Browsed", pageData);

    },

    productViewed() {

        if (typeof clevertap === "undefined") return;
        if (!window.productData) return;

        const product = window.productData;

            clevertap.event.push("Product Viewed", {
            "Product ID": product.id,
            "Variant ID": product.variantId,
            "Product Name": product.title,
            "Vendor": product.vendor,
            "Collection": product.collection,
            "Product Type": product.type,
            "SKU": product.sku,
            "Price": product.price,
            "Currency": product.currency,
            "Product URL": product.url,
            "Image": product.image,
            "Availability": product.available
        });

        console.log("🟢 CleverTap :: Product Viewed", product);

    },

   categoryViewed() {

    if (typeof clevertap === "undefined") return;
    if (!window.collectionData) return;

    const collection = window.collectionData;

    clevertap.event.push("Category Viewed", {

        "Collection ID": collection.id,

        "Collection Name": collection.title,

        "Collection Handle": collection.handle,

        "Collection URL": collection.url,

        "Products Count": collection.productsCount,

        "Total Products": collection.allProductsCount,

        "Description": collection.description

    });

    console.log("🟡 CleverTap :: Category Viewed", collection);

},

    productSearched() {

        console.log("🟣 Product Searched");

    },

    addToCart() {

        if (typeof clevertap === "undefined") return;
        if (!window.productData) return;

        const product = window.productData;

        clevertap.event.push("Added To Cart", {
            "Product ID": product.id,
            "Variant ID": product.variantId,
            "Product Name": product.title,
            "Vendor": product.vendor,
            "Collection": product.collection,
            "Product Type": product.type,
            "SKU": product.sku,
            "Price": product.price,
            "Currency": product.currency,
            "Product URL": product.url,
            "Product Image": product.image,
            "Availability": product.available,
            "Quantity": 1
        });

        console.log("🟠 CleverTap :: Added To Cart", product);

    },
   checkoutStarted() {

    if (typeof clevertap === "undefined") return;
    if (!window.productData) return;

    const product = window.productData;

    let total = 0;

    const totalElement =
        document.querySelector(".totals__total-value") ||
        document.querySelector(".cart__footer .price") ||
        document.querySelector(".totals .price");

    if (totalElement) {
        total = totalElement.innerText.replace(/[^\d.]/g, "");
    }

    const eventData = {

        "Product ID": product.id,
        "Variant ID": product.variantId,
        "Product Name": product.title,
        "Vendor": product.vendor,
        "Collection": product.collection,
        "Product Type": product.type,
        "SKU": product.sku,
        "Price": product.price,
        "Currency": product.currency,
        "Product URL": product.url,
        "Availability": product.available,
        "Quantity": 1,
        "Cart Value": total,
        "Checkout Time": new Date().toISOString()

    };

    console.log("🟣 CleverTap :: Checkout Started", eventData);

    clevertap.event.push("Checkout Started", eventData);

}

};

console.log("✅ CleverTap Events JS Loaded");

document.addEventListener("DOMContentLoaded", function () {

    const pageType = window.shopifyPageData?.pageType;

    if (!pageType) return;

    switch (pageType) {

        case "index":
            CleverTapEvents.pageViewed();
            break;

        case "product":
            CleverTapEvents.productViewed();
            break;

        case "collection":
            CleverTapEvents.categoryViewed();
            break;

        case "search":
            CleverTapEvents.productSearched();
            break;

    }

});
document.addEventListener("submit", function (e) {

    const form = e.target;

    if (form.id !== "CartDrawer-Form") return;

    console.log("🟣 Checkout Started");

    CleverTapEvents.checkoutStarted();

});